export type SignUpType = "OWNER" | "PHARMACIST" | "STUDENT";

export type SignUpStep =
    | "type"
    | "agree"
    | "phone"
    | "phoneAuth"
    | "userInfo"
    | "licenseInfo"
    | "certificateInfo"
    | "pharmacyInfo"
    | "path"
    | "done";

/* 선택한 type이 이후 단계(면허/재학증명/약국)를 결정한다. */

export const getSignUpSteps = (type?: SignUpType): SignUpStep[] => {

    const common: SignUpStep[] = [
        "type", 
        "agree", 
        "phone", 
        "phoneAuth", 
        "userInfo"
    ];

    if (type === "OWNER") {
        return [
            ...common, 
            "licenseInfo", 
            "pharmacyInfo", 
            "path", 
            "done"
        ];
    }

    if (type === "PHARMACIST") {
        return [
            ...common, 
            "licenseInfo", 
            "path", 
            "done"
        ];
    }

    if (type === "STUDENT") {
        return [
            ...common, 
            "certificateInfo", 
            "path", 
            "done"
        ];
    }

    return common;
};

/* 다음 단계 계산: 버튼 클릭 시 이동할 단계 */

export const getNextStep = (step: SignUpStep, type?: SignUpType) => {
    const steps = getSignUpSteps(type);
    return steps[steps.indexOf(step) + 1];
};

/* 진행률 계산: progress bar 렌더링을 위함 */

export const getStepProgress = (step: SignUpStep, type?: SignUpType) => {

    /* 유형 선택/ 약관 /완료 는 진행률에서 제외 */

    const steps = getSignUpSteps(type).filter(
        (item) => item !== "type" && item !== "agree" && item !== "done"
    );

    const index = steps.indexOf(step);
    if (index < 0) return 0;
    return Math.round(((index + 1) / steps.length) * 100);
};
